import { usePublishedCollections } from 'marketplace-ui-common/collections/hooks/usePublishedCollections';
import { useParams } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';

/** Fetches the current collection based on the collection slug in the URL.  */
export function useCollectionQuery() {
  const appContext = useAppContext();
  const {
    collectionSlug
  } = useParams();
  const publishedCollections = usePublishedCollections({
    appContext,
    offeringType: 'APP'
  });

  // URL does not have a collection slug (this is common)
  if (!collectionSlug) {
    return {
      loading: false,
      data: undefined,
      error: undefined
    };
  }
  if (publishedCollections.requestState === 'PENDING') {
    return {
      loading: true,
      data: undefined,
      error: undefined
    };
  }
  const collection = publishedCollections.getCollectionBySlug(collectionSlug);
  if (!collection) {
    return {
      loading: false,
      data: undefined,
      error: new Error('Collection not found')
    };
  }
  return {
    loading: false,
    data: collection,
    error: undefined
  };
}